<template>
  <div>contact_events_tasks</div>
</template>

<script>
export default {
  name: "contact_events_tasks"
}
</script>

<style scoped>

</style>
